import { render, staticRenderFns } from "./veJkyMeetRemindEdit.vue?vue&type=template&id=364a4f78&scoped=true"
import script from "./veJkyMeetRemindEdit.vue?vue&type=script&lang=js"
export * from "./veJkyMeetRemindEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a4f78",
  null
  
)

export default component.exports